export default __webpack_public_path__ + "static/media/biologia.5e4c3020.svg";